export default __webpack_public_path__ + "static/media/Seminarhaus.e74e3e4c.webp";